import { useForm } from "@iyk/vf-forms"
import { useAnalytics } from "@iyk/vf-observability/react"
import { Playlist } from "@iyk/vf-ui"
import { GlobalRoutes } from "../../react-router/routes.ts"

export type LogoutButtonProps = {
  formClassName?: string
  buttonClassName?: string
}

export const LogoutButton = ({ formClassName, buttonClassName }: LogoutButtonProps) => {
  const { Form } = useForm()
  const analytics = useAnalytics()
  const playlist = Playlist.useAudioPlayer()

  const handleSubmit = () => {
    analytics.reset()
    playlist.reset()
  }

  return (
    <Form method="post" action={GlobalRoutes.logout} className={formClassName} onSubmit={handleSubmit}>
      <button type="submit" className={buttonClassName}>
        Logout
      </button>
    </Form>
  )
}
